import { loadable } from '@fiverr-private/perseus';
import CalendarConfig from '../../../../docs/builderCalendarComponents/Calendar.json';

const Calendar = loadable(() => import(/* webpackChunkName: "Calendar" */ './calendar'));
Calendar.displayName = 'Calendar';

const CALENDAR_COMPONENTS_CONFIG = {
    components: [
        {
            element: Calendar,
            componentConfig: CalendarConfig,
        },
    ],
    category: 'Calendar',
};

export default CALENDAR_COMPONENTS_CONFIG;
